// extracted by mini-css-extract-plugin
export default {"box":"TrackBox_box__hih2n","wrapper":"TrackBox_wrapper__Ajl7i","title":"TrackBox_title__E7gyE","line":"TrackBox_line__v7T6r","content":"TrackBox_content__3Vb8Z"};